import type { RngState } from "../worldState.ts";

export function createRngState(seed: number): RngState {
  return { seed, state: seed >>> 0 };
}

export function nextRngUnit(rng: RngState): { value: number; rng: RngState } {
  let state = (rng.state + 0x6d2b79f5) >>> 0;
  let t = Math.imul(state ^ (state >>> 15), 1 | state);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  return { value, rng: { seed: rng.seed, state } };
}

export function pickWeightedIndex(
  weights: readonly number[],
  rng: RngState,
): { index: number; rng: RngState } {
  const total = weights.reduce((sum, weight) => sum + weight, 0);
  const rollResult = nextRngUnit(rng);
  let roll = rollResult.value * total;

  for (let index = 0; index < weights.length; index++) {
    roll -= weights[index]!;
    if (roll <= 0) {
      return { index, rng: rollResult.rng };
    }
  }

  return { index: weights.length - 1, rng: rollResult.rng };
}
